export default "__VITE_ASSET__db0cf2e3__"